// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
Vue.use(Mint)
import '../src/assets/css/base.css'
import 'mint-ui/lib/style.css'
import '../src/assets/css/weui.css'
import './network/networkFilter'
import httpUtils from './network/httpUtils'
import store from './store/index'
import utils from './assets/js/utils'
import Address from './network/Address'
Vue.prototype.$http = httpUtils
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
import { Lazyload } from 'mint-ui';
Vue.use(Lazyload);

import VConsole from 'vconsole'
new VConsole()

import watermark from './assets/js/watermark.js'
Vue.prototype.$watermark = watermark;

if (process.env.NODE_ENV == 'production') {
  
}
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
//路由拦截器
router.beforeEach((to, from, next) => {

  //是否已清缓存
  let isCase = localStorage.getItem("isCase");
  if(!isCase){
    console.log(isCase,'isCaseisCaseisCase');
    store.commit('setAdywOpenId','');
    store.commit('setAyyOpenId','');
    store.commit('setWxUserInfo','');
    store.commit('setUserInfo','');
    localStorage.setItem("isCase", true);
    console.log(localStorage.getItem("isCase"),'ssssisCaseisCaseisCase');
  }

  //设置title
  document.title = to.meta.title;
  if(window.location.href.indexOf('testPage') != -1){
    next();
    return false;
  }
  if (!utils.wechatUtil.isWeiXin()) {
    alert("请在微信浏览器打开")
    return false;
  }

  //不需要授权 直接通过
  if(utils.URL.getUrlKey("isAuth") == 'false'){
    next();
    return false;
  }
  
  /* if(utils.URL.getUrlKey("authType") == 'adyw'){
    if(!store.state.adywOpenId || store.state.adywOpenId == ''){
      store.commit('setAdywOpenId', 'oX0Lqwn7iBCGBr0IjOfIUYlzmyXQ');
    }
    if(!store.state.wxUserInfo || store.state.wxUserInfo == ''){
      store.commit('setWxUserInfo',{"headImgUrl":"http://thirdwx.qlogo.cn/mmopen/vi_32/05H6bylvFC2Xb4A7uKdRiaUwoP3M068NC041NJiao0sSgBicJrbBCbILlpqibwLNPSWoFAjNrkCdjcalNlaDYmUficw/132","openid":"oX0Lqwu7eXtv3j_zHZ8IwWi2r4ro","nickName":"晓风残月"});
    }
    next();
    return false; 
  } */

  if(window.location.href.indexOf('127.0.0.1') != -1 || window.location.href.indexOf('localhost') != -1 || window.location.href.indexOf('192.168.100.151') != -1){
    if(window.location.href.indexOf('filmInvest') != -1){
      Vue.prototype.$watermark.set(store.state.wxUserInfo.realName || store.state.wxUserInfo.nickName || '善为影业');
    }
    if(!store.state.adywOpenId || store.state.adywOpenId == ''){
      store.commit('setAdywOpenId', 'oX0Lqwu7eXtv3j_zHZ8IwWi2r4ro');
    }
    if(!store.state.ayyOpenId || store.state.ayyOpenId == ''){
      store.commit('setAyyOpenId', 'oaPUL1tpuyX__Za-uXqQUwmxBOPQ');
    }
    if(!store.state.isPerfect || store.state.isPerfect == ''){
      store.commit('setIsPerfect', true);
    }
    if(!store.state.wxUserInfo || store.state.wxUserInfo == ''){
      store.commit('setWxUserInfo',{"headImgUrl":"http://thirdwx.qlogo.cn/mmopen/vi_32/05H6bylvFC2Xb4A7uKdRiaUwoP3M068NC041NJiao0sSgBicJrbBCbILlpqibwLNPSWoFAjNrkCdjcalNlaDYmUficw/132","openid":"oX0Lqwu7eXtv3j_zHZ8IwWi2r4ro","nickName":"晓风残月"});
      Vue.prototype.$watermark.set(store.state.wxUserInfo.realName || store.state.wxUserInfo.nickName || '善为影业');
    }
    if(!store.state.userInfo || store.state.userInfo == ''){
      store.commit('setUserInfo',{"realName":"刘勇","expireTime":"2019-12-31 23:59:59","rejectReason":"","availableAmount":4.4,"stateName":"可使用","publishUserName":"善为影业","mobile":"13538189575","freezeamount":0.3,"state":2,"userId":"3264","auditState":2,"auditStateName":"审核通过"});
    }
    if(!store.state.cinemaUserInfo || store.state.cinemaUserInfo == ''){
      store.commit('setCinemaUserInfo',{"isWechatPerfect":true,"cinemaInfo":"","userId":"3264","isCinemaPerfect":false,"wechatInfo":{"realName":"刘勇","rejectReason":"","ghNumber":"gh_2156ef9cbf8n","accountType":2,"cinemaName":"","cinemaCode":"","businessLicensePicUrl":"","wechatNumber":"tddd","wechatName":"天大地大","auditState":2,"auditStateName":"审核通过"}});
    }
    next();
    return false;
  }
  
  if(window.location.href.indexOf('writeOff') != -1 || window.location.href.indexOf('bindWechatCheckPhone') != -1){
    next();
    return false;
  }
  

  if(window.location.href.indexOf('filmInvest') != -1){
    console.log('进入影投路由',localStorage.getItem("adywOpenId"));
    if(!localStorage.getItem("adywOpenId")){
      let isBeCode = utils.URL.isUrlKey("code");
      if(isBeCode){
        //调取接口 code 换 openId
        let code = utils.URL.getUrlKey("code");
        Vue.prototype.$http.post(Address.common.adywAuth(), {
          authCode: code,
          authScope: 'snsapi_userinfo'
        }, function(res){
          if(res.code == '0'){
            store.commit('setAdywOpenId', res.data.openid);
            store.commit('setWxUserInfo', res.data);
            Vue.prototype.$watermark.set(store.state.wxUserInfo.realName || store.state.wxUserInfo.nickName || '善为影业');
            next();
            return false;
          }else{
            alert(res.msg);
            return false;
          }
        });
      }else{
        window.location.href = getReplaceAuthUrl('adyw');
        return false;
      }
    }else{
      Vue.prototype.$watermark.set(store.state.wxUserInfo.realName || store.state.wxUserInfo.nickName || '善为影业');
      next();
      return false;
    }
  }else if(!localStorage.getItem("adywOpenId") || !localStorage.getItem("ayyOpenId")){
    //URL是否存在授权code
    let isBeCode = utils.URL.isUrlKey("code");
    if(isBeCode){
      //判断code的来源公众号
      let type = utils.URL.getUrlKey("state");
      let code = utils.URL.getUrlKey("code");
      if(type == 'adyw'){//爱电影网
        //调取接口 code 换 openId
        Vue.prototype.$http.post(Address.common.adywAuth(), {
          authCode: code,
          authScope: 'snsapi_userinfo'
        }, function(res){
          if(res.code == '0'){
            store.commit('setAdywOpenId', res.data.openid);
            store.commit('setWxUserInfo', res.data);
            //判断爱影院是否授权
            if(!localStorage.getItem("ayyOpenId") || localStorage.getItem("ayyOpenId") == ''){
              window.location.href = getReplaceAuthUrl('ayy');
              return false;
            }
            if(to.path.indexOf('cinema') != -1){
              getCinemaUserInfo(next);
            }else{
              getUserInfo(next);
            }
          }else{
            alert(res.msg);
            return false;
          }
        });
      }else{//爱影院
        //调取接口 code 换 openId
        Vue.prototype.$http.post(Address.common.ayyAuth(), {
          authCode: code,
          authScope: 'snsapi_base'
        }, function(res){
          if(res.code == '0'){
            store.commit('setAyyOpenId', res.data.openid);
            //store.commit('setWxUserInfo', res.data);
            //判断爱电影网是否授权
            if(!localStorage.getItem("adywOpenId")){
              window.location.href = getReplaceAuthUrl('adyw');
              return false;
            }
            if(to.path.indexOf('cinema') != -1){
              getCinemaUserInfo(next);
            }else{
              getUserInfo(next);
            }
          }else{
            alert(res.msg);
            return false;
          }
        });
      }
    }else{
      //判断爱电影网是否授权
      if(!localStorage.getItem("adywOpenId")){
        window.location.href = getReplaceAuthUrl('adyw');
        return false;
      }else{
        window.location.href = getReplaceAuthUrl('ayy');
        return false;
      }
    }
  }else{
    if(to.path.indexOf('cinema') != -1){
      getCinemaUserInfo(next);
    }else{
      getUserInfo(next);
    }
  }

  function getUserInfo(next){
    if(localStorage.getItem("userInfo")){
      next();
      return false;
    }
    Vue.prototype.$http.post(Address.studio.queryUserInfo(),{
      adywOpenid: store.state.adywOpenId,
      ayyOpenid: store.state.ayyOpenId
    }, function(res){
      if(res.code == '0'){
        console.log(res, "userInfo")
        store.commit('setIsPerfect', res.data.isPerfect);
        store.commit('setUserInfo', res.data.publishUserInfo);
        next();
      }
    });
  }

  function getCinemaUserInfo(next){
    if(localStorage.getItem("cinemaUserInfo")){
      next();
      return false;
    }
    Vue.prototype.$http.post(Address.cinema.queryCinemaInfo(),{
      adywOpenid: store.state.adywOpenId,
      ayyOpenid: store.state.ayyOpenId
    }, function(res){
      if(res.code == '0'){
        store.commit('setCinemaUserInfo', res.data);
        next();
      }
    });
  }

  function getReplaceAuthUrl(type){
    let url = encodeURIComponent(window.location.href);
    let authType,appId;
    if(type == 'adyw'){
      authType = 'snsapi_userinfo'
      //生产  wx887eb6a548def3a4
       appId = 'wx9b3e094c3993e330';
      //测试 
       // appId = 'wx9d0a56d3787f157a';
    }else if(type == 'ayy'){
      authType = 'snsapi_base';
      appId = 'wx3bbc857b282a0261';
    }
    url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=${authType}&state=${type}#wechat_redirect`;
    return url;
  }

})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js